import { Component } from '@angular/core';
import { IViewablePhoto } from '../../../models/customer-orders/orders';
import { IPreviewableDocument } from '../../../models/documents/document.model';

/**
 * DOVE-2362 / DOVE-2538 — scan photo viewer. app-document-preview already handles image
 * display, zoom and download, so this is only the dialog shell around it.
 */
@Component({
	selector: 'app-order-line-photo-dialog',
	templateUrl: './order-line-photo-dialog.component.html'
})
export class OrderLinePhotoDialogComponent {
	visible = false;
	photo: IViewablePhoto | null = null;
	photoUrl: string | null = null;
	previewDocument: IPreviewableDocument | null = null;

	open(photo: IViewablePhoto | null, photoUrl: string | null): void {
		if (!photo || !photoUrl) return;

		this.photo = photo;
		this.photoUrl = photoUrl;
		this.previewDocument = {
			fileName: photo.file_name,
			isPdf: false,
			isImage: true
		};
		this.visible = true;
	}

	close(): void {
		this.visible = false;
		this.onHide();
	}

	onHide(): void {
		this.previewDocument = null;
		this.photo = null;
		this.photoUrl = null;
	}

	download(): void {
		if (!this.photo || !this.photoUrl) return;

		const link = document.createElement('a');
		link.href = this.photoUrl;
		link.download = this.photo.file_name;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}
